/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Step_Verify_DescInputs */

const en_admin_indexnow_step_verify_desc = /** @type {(inputs: Admin_Indexnow_Step_Verify_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The site serves the key at /your-key.txt automatically, search engines read it to confirm you own the site.`)
};

/**
* | output |
* | --- |
* | "The site serves the key at /your-key.txt automatically, search engines read it to confirm you own the site." |
*
* @param {Admin_Indexnow_Step_Verify_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_step_verify_desc = /** @type {((inputs?: Admin_Indexnow_Step_Verify_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Step_Verify_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_step_verify_desc(inputs)
});
export { admin_indexnow_step_verify_desc as "admin.indexnow.step_verify_desc" }